import { ReactElement, ReactNode, useMemo } from 'react';
import styles from './ui-filter.module.scss';
import { UIText } from '../ui-text';
import { charcoal, fontColor, moonlight } from '../../styles';
import { UIIcon } from '../ui-icon';

type UIFilterHeaderProps = {
    text: string;
    icon?: ReactNode;
    pillText?: string;
    pillTextColor?: string;
    pillBackgroundColor?: string;
    pillPosition?: 'center' | 'right';
};

export function UIFilterHeader(props: UIFilterHeaderProps): ReactElement {
    const {
        text,
        icon,
        pillText,
        pillTextColor = fontColor,
        pillBackgroundColor = moonlight,
        pillPosition = 'center'
    } = props;

    const pillIcon = useMemo(() => {
        if (pillText) {
            return (
                <div
                    className={styles.pillContainer}
                    style={{
                        backgroundColor: pillBackgroundColor,
                        color: pillTextColor
                    }}
                >
                    {pillText}
                </div>
            );
        } else {
            return undefined;
        }
    }, [pillText, pillTextColor, pillBackgroundColor]);

    return (
        <>
            {icon}
            <UIText>{text}</UIText>
            {pillPosition === 'center' && pillIcon}
            <UIIcon name="chevron-down" size={16} color={charcoal} />
            {pillPosition === 'right' && pillIcon}
        </>
    );
}
